import { createSlice } from "@reduxjs/toolkit";

const bugReportSlice = createSlice({
  name: "bugReport",
  initialState: {
    open: false,
  },
  reducers: {
    openBugReportModal: (state) => {
      state.open = true;
    },
    closeBugReportModal: (state) => {
      state.open = false;
    },
  },
});

export const { openBugReportModal, closeBugReportModal } = bugReportSlice.actions;

export const selectBugReportOpen = (state) => state.bugReport?.open;

export default bugReportSlice.reducer;